export const stringMaxLength = 255;
export const textMaxLength = 1000;
export const spotNumberMaxValue = 999999999;
export const spotNumberMaxLength = 10;
export const spotRateMaxValue = 9999999.99;
export const cpmRateMaxValue = 9999999999.99;
export const minValue = 0;
export const maxPercentageValue = 100;
